<div class="pdf-datetime-preview" [style.fontSize.px]="fontSize">
  <span *ngIf="showLabel && label" class="field-label">{{ label }}:</span>
  <span class="field-value">{{ displayValue }}</span>
</div>
